import { useState } from "react";
import EnrichmentModal from "./EnrichmentModal";
import BookCallModal from "@/components/BookCallModal";

/**
 * Single shared CTA system for the Manchester page.
 * Primary: "Get my free valuation" (always #E1E820 bg, #1A1A1A text)
 * Secondary: "Book a call" (equal visual weight, side by side)
 */
export default function CTAButtons({ dark = false, align = "center", size = "normal", includeMicrocopy = false, microcopyText }) {
  const [showModal, setShowModal] = useState(false);
  const [showBookCall, setShowBookCall] = useState(false);

  const alignItems = align === "left" ? "flex-start" : "center";
  const padding = size === "large" ? "16px 32px" : "14px 26px";
  const fontSize = size === "large" ? 15.5 : 14.5;

  const mc = microcopyText || "Free earning estimate, sent within 24 hours. No obligation, and no call unless you ask.";

  return (
    <>
      <div style={{ display: "flex", flexDirection: "column", alignItems: alignItems, gap: 10, width: "100%" }}>
        <div
          className="cta-btn-row"
          style={{
            display: "flex",
            gap: 12,
            alignItems: "center",
            flexWrap: "wrap",
            justifyContent: align === "left" ? "flex-start" : "center",
            width: "100%",
            maxWidth: 560,
          }}
        >
          <button
            onClick={() => setShowModal(true)}
            style={{
              background: "#CD533B",
              color: "#fff",
              border: "none",
              borderRadius: 8,
              padding,
              fontFamily: "'Inter', sans-serif",
              fontSize,
              fontWeight: 600,
              cursor: "pointer",
              transition: "background 0.2s",
              flex: "1 1 220px",
              whiteSpace: "nowrap",
            }}
            onMouseEnter={(e) => (e.currentTarget.style.background = "#B8462F")}
            onMouseLeave={(e) => (e.currentTarget.style.background = "#CD533B")}
          >
            Get my free valuation
          </button>
          <button
            onClick={() => setShowBookCall(true)}
            style={{
              background: "transparent",
              color: dark ? "#fff" : "#112215",
              border: "1.5px solid " + (dark ? "rgba(255,255,255,0.2)" : "#D5D0BE"),
              borderRadius: 8,
              padding,
              fontFamily: "'Inter', sans-serif",
              fontSize,
              fontWeight: 600,
              cursor: "pointer",
              transition: "background 0.2s",
              flex: "1 1 160px",
              whiteSpace: "nowrap",
            }}
            onMouseEnter={(e) => (e.currentTarget.style.background = dark ? "rgba(255,255,255,0.08)" : "rgba(17,34,21,0.06)")}
            onMouseLeave={(e) => (e.currentTarget.style.background = "transparent")}
          >
            Book a call
          </button>
        </div>
        {includeMicrocopy && (
          <p
            style={{
              fontFamily: "'Inter', sans-serif",
              fontSize: 13,
              color: dark ? "rgba(255,255,255,0.55)" : "#5C7268",
              margin: "0 0 20px 0",
              lineHeight: 1.5,
              textAlign: align === "left" ? "left" : "center",
              maxWidth: 480,
            }}
          >
            {mc}
          </p>
        )}
      </div>

      {showModal && <EnrichmentModal mode="full" onClose={() => setShowModal(false)} onSubmitted={() => setShowModal(false)} />}
      {showBookCall && <BookCallModal onClose={() => setShowBookCall(false)} onGetValuation={() => { setShowBookCall(false); setShowModal(true); }} />}

      <style>{`
        @media (max-width: 520px) {
          .cta-btn-row { flex-direction: column !important; }
          .cta-btn-row button { flex: 1 1 auto !important; width: 100% !important; }
        }
      `}</style>
    </>
  );
}